import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import { Element } from 'react-scroll'

import ApproverActionBarContainer from '../ApproverActionBar/index'
import ApproverContainer from '../ApproverSection/index'
import CommentContainer from '../CommentSection/index'
import HistoryContainer from '../HistorySection/index'
import theme from './MainPanel.scss'

class MainPanel extends Component {
  render() {
    let approverActionBar = null,
      approverSection = null,
      commentSection = null,
      specSection = null,
      historySection = null

    if (this.props.currentApproval){
      approverActionBar = <ApproverActionBarContainer/>
      commentSection = <CommentContainer/>
      historySection = <HistoryContainer/>
      approverSection = <ApproverContainer/>
      // specSection =
      //   <DescriptionSection
      //     approvals = { approvals }
      //     currentApproval={ currentApproval }
      //     hideValuesChangedSection={true}
      //     hideButtons={true}
      //     loadSavedData={true}
      //   />
    }

    return (
      <Flex id='scrollContainer' column auto class={theme.mainPanel}>
        <Element name='specContainer'>
          { /*specSection*/ }
        </Element>
        <Element name='approvalContainer'>
          { approverSection }
        </Element>
        <Element name='commentContainer'>
          { commentSection }
        </Element>
        <Element name='historyContainer'>
          { historySection }
        </Element>
        <Box auto/>
				{ approverActionBar }
      </Flex>
    )
  }
}

export default CSSModules(MainPanel, theme)
